import { connect } from 'react-redux';
import { getSegments } from '../../reducers/analyticsApp';
import MultipleValuesSelector from '../../components/filter/MultipleValuesSelector';

const mapStateToProps = (state) => ({
  values: (getSegments(state) || []).map((e) => e.name).sort((a, b) => a.localeCompare(b)),
});

export default connect(mapStateToProps)(MultipleValuesSelector);
